import { Flex } from "@paguelofacil/pf-components";
import { useEffect, useState } from "react";
import Select, { components } from "react-select";

const Control = ({ children, ...props }) => {
    const style = { cursor: "pointer" };

    const value = props.getValue()[0];

    return (
        <components.Control {...props}>
            {props.getValue().length ? (
                <img
                    style={style}
                    src={`https://assets.paguelofacil.com/images/widget/${value?.value}.png`}
                    width="16"
                    alt="coin"
                />
            ) : (
                <></>
            )}
            {children}
        </components.Control>
    );
};

const Option = ({ children, ...props }) => {
    const style = { marginRight: "0.5rem" };

    const value = props?.data;
    props.className = "option-select-custom";

    return (
        <components.Option {...props}>
            <img
                style={style}
                src={`https://assets.paguelofacil.com/images/widget/${value?.value}.png`}
                width="16"
                alt="logo coin"
            />
            {children}
        </components.Option>
    );
};

export const SelectWithImage = ({ onChange, placeholder, id, objectOptions, defaultValue, value, isLoading }) => {
    const [valueInput, setValueInput] = useState(value);

    const onChangeInput = valueChange => {
        onChange(valueChange);
        setValueInput(valueChange);
    };

    useEffect(() => {
        if (defaultValue) {
            onChangeInput(defaultValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue]);

    return (
        <Flex direction="column" align="stretch" gap="0.25rem">
            <Select
                className="select-options"
                placeholder={placeholder}
                id={id}
                options={objectOptions}
                onChange={value => onChangeInput(value)}
                value={valueInput}
                isLoading={isLoading}
                components={{ Control, Option }}
            />
        </Flex>
    );
};
